module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfCRc4EsA.746a38a0.woff2";